//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Haalt de lijst met gebruikersgroepen op.
     * @return Success
     */
    gebruikersgroepenByGebruikersgroepIdGet(gebruikersgroepId: string): Promise<GebruikersgroepenOutput> {
        let url_ = this.baseUrl + "/Gebruikersgroepen/{gebruikersgroepId}";
        if (gebruikersgroepId === undefined || gebruikersgroepId === null)
            throw new Error("The parameter 'gebruikersgroepId' must be defined.");
        url_ = url_.replace("{gebruikersgroepId}", encodeURIComponent("" + gebruikersgroepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroepenByGebruikersgroepIdGet(_response);
        });
    }

    protected processGebruikersgroepenByGebruikersgroepIdGet(response: Response): Promise<GebruikersgroepenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GebruikersgroepenOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een gebruikersgroep.
     * @param gebruikersgroepId De identificatie van de gebruikersgroep
     * @param gebruikersgroep (optional) De te wijzigen gegevens van de gebruikersgroep
     * @return Success
     */
    gebruikersgroepenByGebruikersgroepIdPut(gebruikersgroepId: string, gebruikersgroep: Gebruikersgroep | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Gebruikersgroepen/{gebruikersgroepId}";
        if (gebruikersgroepId === undefined || gebruikersgroepId === null)
            throw new Error("The parameter 'gebruikersgroepId' must be defined.");
        url_ = url_.replace("{gebruikersgroepId}", encodeURIComponent("" + gebruikersgroepId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gebruikersgroep);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroepenByGebruikersgroepIdPut(_response);
        });
    }

    protected processGebruikersgroepenByGebruikersgroepIdPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert de gegevens van de gebruikersgroep met het betreffende id.
     * @param gebruikersgroepId De identificatie van de gebruikersgroep
     * @return Success
     */
    gebruikersgroepenByGebruikersgroepIdDelete(gebruikersgroepId: string): Promise<void> {
        let url_ = this.baseUrl + "/Gebruikersgroepen/{gebruikersgroepId}";
        if (gebruikersgroepId === undefined || gebruikersgroepId === null)
            throw new Error("The parameter 'gebruikersgroepId' must be defined.");
        url_ = url_.replace("{gebruikersgroepId}", encodeURIComponent("" + gebruikersgroepId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroepenByGebruikersgroepIdDelete(_response);
        });
    }

    protected processGebruikersgroepenByGebruikersgroepIdDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Haalt de lijst met gebruikersgroepen op.
     * @param organisatieId (optional) De identificatie van de organisatie
     * @return Success
     */
    gebruikersgroepenGet(organisatieId: string | null | undefined): Promise<GebruikersgroepenOutput> {
        let url_ = this.baseUrl + "/Gebruikersgroepen?";
        if (organisatieId !== undefined && organisatieId !== null)
            url_ += "organisatieId=" + encodeURIComponent("" + organisatieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroepenGet(_response);
        });
    }

    protected processGebruikersgroepenGet(response: Response): Promise<GebruikersgroepenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GebruikersgroepenOutput>(null as any);
    }

    /**
     * Maakt een nieuwe gebruikersgroep aan.
     * @param gebruikersgroep (optional) De gegevens van de nieuwe gebruikersgroep
     * @return Success
     */
    gebruikersgroepenPost(gebruikersgroep: Gebruikersgroep | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Gebruikersgroepen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gebruikersgroep);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroepenPost(_response);
        });
    }

    protected processGebruikersgroepenPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Zet medewerkers over naar een andere gebruikersgroep en verwijder eventueel de oorspronkelijke gebruikersgroep
     * @param deleteFrom (optional) 
     * @return Success
     */
    gebruikersgroepenFromByGebruikersgroepIdFromToByGebruikersgroepToPost(gebruikersgroepIdFrom: string, gebruikersgroepTo: string, deleteFrom: boolean | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Gebruikersgroepen/From/{gebruikersgroepIdFrom}/To/{gebruikersgroepTo}";
        if (gebruikersgroepIdFrom === undefined || gebruikersgroepIdFrom === null)
            throw new Error("The parameter 'gebruikersgroepIdFrom' must be defined.");
        url_ = url_.replace("{gebruikersgroepIdFrom}", encodeURIComponent("" + gebruikersgroepIdFrom));
        if (gebruikersgroepTo === undefined || gebruikersgroepTo === null)
            throw new Error("The parameter 'gebruikersgroepTo' must be defined.");
        url_ = url_.replace("{gebruikersgroepTo}", encodeURIComponent("" + gebruikersgroepTo));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deleteFrom);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGebruikersgroepenFromByGebruikersgroepIdFromToByGebruikersgroepToPost(_response);
        });
    }

    protected processGebruikersgroepenFromByGebruikersgroepIdFromToByGebruikersgroepToPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Haalt alle HDN Nodenummers op van een organisatie.
     * @param organisatieId Identificatie van de organisatie
     * @return Success
     */
    organisatieByOrganisatieIdHdnNodenummersGet(organisatieId: string): Promise<HdnNodenummersOutput> {
        let url_ = this.baseUrl + "/Organisatie/{organisatieId}/HdnNodenummers";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatieByOrganisatieIdHdnNodenummersGet(_response);
        });
    }

    protected processOrganisatieByOrganisatieIdHdnNodenummersGet(response: Response): Promise<HdnNodenummersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HdnNodenummersOutput>(null as any);
    }

    /**
     * Haalt het HDN nodenummer op dat geldt voor de gegeven vestiging, indien ingesteld.
     * @param vestigingId Identificatie van de vestiging
     * @return Success
     */
    vestigingenByVestigingIdHdnNodenummersGet(vestigingId: string): Promise<HdnNodenummersOutput> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/HdnNodenummers";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingenByVestigingIdHdnNodenummersGet(_response);
        });
    }

    protected processVestigingenByVestigingIdHdnNodenummersGet(response: Response): Promise<HdnNodenummersOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as HdnNodenummersOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HdnNodenummersOutput>(null as any);
    }

    /**
     * Maakt een nieuw HDN Nodenummers aan.
     * @param organisatieId Identificatie van de organisatie
     * @param hdnNodenummer (optional) Gegevens van het HDN nodenummer
     * @return Success
     */
    organisatiesByOrganisatieIdHdnNodenummersPost(organisatieId: string, hdnNodenummer: HdnNodenummer | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}/HdnNodenummers";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hdnNodenummer);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesByOrganisatieIdHdnNodenummersPost(_response);
        });
    }

    protected processOrganisatiesByOrganisatieIdHdnNodenummersPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een HDN nodenummer.
     * @param hdnNodenummerId Identificatie van het HDN nodenummer
     * @param hdnNodenummer (optional) Gegevens van het HDN nodenummer
     * @return Success
     */
    hdnNodenummersByHdnNodenummerIdPut(hdnNodenummerId: string, hdnNodenummer: HdnNodenummer | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/HdnNodenummers/{hdnNodenummerId}";
        if (hdnNodenummerId === undefined || hdnNodenummerId === null)
            throw new Error("The parameter 'hdnNodenummerId' must be defined.");
        url_ = url_.replace("{hdnNodenummerId}", encodeURIComponent("" + hdnNodenummerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(hdnNodenummer);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHdnNodenummersByHdnNodenummerIdPut(_response);
        });
    }

    protected processHdnNodenummersByHdnNodenummerIdPut(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van het HDN nodenummer met de betreffende id.
     * @param hdnNodenummerId Identificatie van het HDN nodenummer
     * @return Success
     */
    hdnNodenummersByHdnNodenummerIdDelete(hdnNodenummerId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/HdnNodenummers/{hdnNodenummerId}";
        if (hdnNodenummerId === undefined || hdnNodenummerId === null)
            throw new Error("The parameter 'hdnNodenummerId' must be defined.");
        url_ = url_.replace("{hdnNodenummerId}", encodeURIComponent("" + hdnNodenummerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHdnNodenummersByHdnNodenummerIdDelete(_response);
        });
    }

    protected processHdnNodenummersByHdnNodenummerIdDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Activeert het HDN Nodenummer met de betreffende id.
     * @param hdnNodenummerId Identificatie van het HDN nodenummer
     * @return Success
     */
    hdnNodenummersByHdnNodenummerIdActiverenPost(hdnNodenummerId: string): Promise<void> {
        let url_ = this.baseUrl + "/HdnNodenummers/{hdnNodenummerId}/Activeren";
        if (hdnNodenummerId === undefined || hdnNodenummerId === null)
            throw new Error("The parameter 'hdnNodenummerId' must be defined.");
        url_ = url_.replace("{hdnNodenummerId}", encodeURIComponent("" + hdnNodenummerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHdnNodenummersByHdnNodenummerIdActiverenPost(_response);
        });
    }

    protected processHdnNodenummersByHdnNodenummerIdActiverenPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft met minimal inspanning aan of de app up is.
     * @return Success
     */
    healthCheckHead(): Promise<void> {
        let url_ = this.baseUrl + "/HealthCheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "HEAD",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHealthCheckHead(_response);
        });
    }

    protected processHealthCheckHead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de licentieovereenkomsten van een organisatie.
     * @param organisatieId (optional) De unieke identificatie van de organisatie
     * @return Success
     */
    licentieovereenkomstenGet(organisatieId: string | null | undefined): Promise<LicentieovereenkomstenOutput> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten?";
        if (organisatieId !== undefined && organisatieId !== null)
            url_ += "organisatieId=" + encodeURIComponent("" + organisatieId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomstenGet(_response);
        });
    }

    protected processLicentieovereenkomstenGet(response: Response): Promise<LicentieovereenkomstenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentieovereenkomstenOutput>(null as any);
    }

    /**
     * Maakt een licentieovereenkomst voor een bepaald product aan voor de organisatie.
     * @param licentieovereenkomst (optional) De gegevens van de licentieovereenkomst
     * @return Success
     */
    licentieovereenkomstenPost(licentieovereenkomst: Licentieovereenkomst | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licentieovereenkomst);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomstenPost(_response);
        });
    }

    protected processLicentieovereenkomstenPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Geeft de licentieovereenkomsten met documenten van een organisatie.
     * @param organisatieId De unieke identificatie van de organisatie
     * @return Success
     */
    licentieovereenkomstenMetDocumentenOrganisatiesByOrganisatieIdGet(organisatieId: string): Promise<LicentieovereenkomstenOutput> {
        let url_ = this.baseUrl + "/LicentieovereenkomstenMetDocumenten/Organisaties/{organisatieId}";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomstenMetDocumentenOrganisatiesByOrganisatieIdGet(_response);
        });
    }

    protected processLicentieovereenkomstenMetDocumentenOrganisatiesByOrganisatieIdGet(response: Response): Promise<LicentieovereenkomstenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentieovereenkomstenOutput>(null as any);
    }

    /**
     * Geeft de licentieovereenkomst met het betreffente id.
     * @param licentieovereenkomstid De unieke identificatie van de licentieovereenkomst
     * @return Success
     */
    licentieovereenkomstenByLicentieovereenkomstidGet(licentieovereenkomstid: string): Promise<LicentieovereenkomstenOutput> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten/{licentieovereenkomstid}";
        if (licentieovereenkomstid === undefined || licentieovereenkomstid === null)
            throw new Error("The parameter 'licentieovereenkomstid' must be defined.");
        url_ = url_.replace("{licentieovereenkomstid}", encodeURIComponent("" + licentieovereenkomstid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomstenByLicentieovereenkomstidGet(_response);
        });
    }

    protected processLicentieovereenkomstenByLicentieovereenkomstidGet(response: Response): Promise<LicentieovereenkomstenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentieovereenkomstenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentieovereenkomstenOutput>(null as any);
    }

    /**
     * Werkt de gegevens van een licentieovereenkomst bij.
     * @param licentieovereenkomstId De unieke identificatie van de licentieovereenkomst
     * @param licentieovereenkomst (optional) De nieuwe gegevens van de licentieovereenkomst
     * @return Success
     */
    licentieovereenkomstenByLicentieovereenkomstIdPut(licentieovereenkomstId: string, licentieovereenkomst: Licentieovereenkomst | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten/{licentieovereenkomstId}";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licentieovereenkomst);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomstenByLicentieovereenkomstIdPut(_response);
        });
    }

    protected processLicentieovereenkomstenByLicentieovereenkomstIdPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert de licentieovereenkomst
     * @param licentieovereenkomstId Unieke identificatie van de licentieovereenkomst
     * @return Success
     */
    licentieovereenkomstenByLicentieovereenkomstIdDelete(licentieovereenkomstId: string): Promise<void> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten/{licentieovereenkomstId}";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomstenByLicentieovereenkomstIdDelete(_response);
        });
    }

    protected processLicentieovereenkomstenByLicentieovereenkomstIdDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Zet de contractvorm van een licentieovereenkomst om van Proef naar Betaald.
     * @param licentieovereenkomstId De unieke identificatie van de licentieovereenkomst
     * @return Success
     */
    licentieovereenkomstBetaaldContractByLicentieovereenkomstIdPut(licentieovereenkomstId: string): Promise<void> {
        let url_ = this.baseUrl + "/Licentieovereenkomst/BetaaldContract/{licentieovereenkomstId}";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomstBetaaldContractByLicentieovereenkomstIdPut(_response);
        });
    }

    protected processLicentieovereenkomstBetaaldContractByLicentieovereenkomstIdPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft de licenties van een organisatie.
     * @return Success
     */
    organisatiesByOrganisatieIdLicentiesGet(organisatieId: string): Promise<LicentiesOutput> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}/Licenties";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesByOrganisatieIdLicentiesGet(_response);
        });
    }

    protected processOrganisatiesByOrganisatieIdLicentiesGet(response: Response): Promise<LicentiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesOutput>(null as any);
    }

    /**
     * Geeft de licenties van een medewerker.
     * @return Success
     */
    medewerkersByMedewerkerIdLicentiesGet(medewerkerId: string): Promise<LicentiesOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Licenties";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdLicentiesGet(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdLicentiesGet(response: Response): Promise<LicentiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesOutput>(null as any);
    }

    /**
     * Geeft de licenties van een productsamenstelling.
     * @param licentieovereenkomstId (optional) 
     * @return Success
     */
    productsamenstellingByProductsamenstellingIdLicentiesGet(licentieovereenkomstId: string | null | undefined, productsamenstellingId: string): Promise<LicentiesDetailsOutput> {
        let url_ = this.baseUrl + "/Productsamenstelling/{productsamenstellingId}/Licenties?";
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        if (licentieovereenkomstId !== undefined && licentieovereenkomstId !== null)
            url_ += "licentieovereenkomstId=" + encodeURIComponent("" + licentieovereenkomstId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstellingByProductsamenstellingIdLicentiesGet(_response);
        });
    }

    protected processProductsamenstellingByProductsamenstellingIdLicentiesGet(response: Response): Promise<LicentiesDetailsOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesDetailsOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesDetailsOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesDetailsOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesDetailsOutput>(null as any);
    }

    /**
     * Maakt een nieuw licentie aan.
     * @param licentie (optional) De gegevens van de nieuwe licentie
     * @return Success
     */
    licentiesPost(licentie: Licentie | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Licenties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licentie);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentiesPost(_response);
        });
    }

    protected processLicentiesPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Wijzigt het aantal licenties
     * @return Success
     */
    licentieovereenkomstByLicentieovereenkomstIdProductsamenstellingByProductsamenstellingIdLicentiesByAantalLicentiesPost(licentieovereenkomstId: string, productsamenstellingId: string, aantalLicenties: number): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Licentieovereenkomst/{licentieovereenkomstId}/Productsamenstelling/{productsamenstellingId}/Licenties/{aantalLicenties}";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        if (aantalLicenties === undefined || aantalLicenties === null)
            throw new Error("The parameter 'aantalLicenties' must be defined.");
        url_ = url_.replace("{aantalLicenties}", encodeURIComponent("" + aantalLicenties));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomstByLicentieovereenkomstIdProductsamenstellingByProductsamenstellingIdLicentiesByAantalLicentiesPost(_response);
        });
    }

    protected processLicentieovereenkomstByLicentieovereenkomstIdProductsamenstellingByProductsamenstellingIdLicentiesByAantalLicentiesPost(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haalt de gegevens van de licentie met het betreffende id op.
     * @param licentieId Identificatie van de licentie
     * @return Success
     */
    licentiesByLicentieIdGet(licentieId: string): Promise<LicentiesOutput> {
        let url_ = this.baseUrl + "/Licenties/{licentieId}";
        if (licentieId === undefined || licentieId === null)
            throw new Error("The parameter 'licentieId' must be defined.");
        url_ = url_.replace("{licentieId}", encodeURIComponent("" + licentieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentiesByLicentieIdGet(_response);
        });
    }

    protected processLicentiesByLicentieIdGet(response: Response): Promise<LicentiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een licentie.
     * @param licentieId De identificatie van de licentie
     * @param licentie (optional) De te wijzigen gegevens van de licentie
     * @return Success
     */
    licentiesByLicentieIdPut(licentieId: string, licentie: Licentie | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Licenties/{licentieId}";
        if (licentieId === undefined || licentieId === null)
            throw new Error("The parameter 'licentieId' must be defined.");
        url_ = url_.replace("{licentieId}", encodeURIComponent("" + licentieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(licentie);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentiesByLicentieIdPut(_response);
        });
    }

    protected processLicentiesByLicentieIdPut(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van de licentie met het betreffende id.
     * @param licentieId De identificatie van de licentie
     * @return Success
     */
    licentiesByLicentieIdDelete(licentieId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Licenties/{licentieId}";
        if (licentieId === undefined || licentieId === null)
            throw new Error("The parameter 'licentieId' must be defined.");
        url_ = url_.replace("{licentieId}", encodeURIComponent("" + licentieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentiesByLicentieIdDelete(_response);
        });
    }

    protected processLicentiesByLicentieIdDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haalt de licenties van een licentieovereenkomst op.
     * @param licentieovereenkomstId Unieke identificatie van de licentieovereenkomst waarvan de licenties moeten worden opgehaald
     * @return Success
     */
    licentieovereenkomstenByLicentieovereenkomstIdLicentiesGet(licentieovereenkomstId: string): Promise<LicentiesOutput> {
        let url_ = this.baseUrl + "/Licentieovereenkomsten/{licentieovereenkomstId}/Licenties";
        if (licentieovereenkomstId === undefined || licentieovereenkomstId === null)
            throw new Error("The parameter 'licentieovereenkomstId' must be defined.");
        url_ = url_.replace("{licentieovereenkomstId}", encodeURIComponent("" + licentieovereenkomstId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLicentieovereenkomstenByLicentieovereenkomstIdLicentiesGet(_response);
        });
    }

    protected processLicentieovereenkomstenByLicentieovereenkomstIdLicentiesGet(response: Response): Promise<LicentiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LicentiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicentiesOutput>(null as any);
    }

    /**
     * Haalt alle medewerkers op van een organisatie.
     * @param organisatieId Identificatie van de organisatie
     * @return Success
     */
    organisatieByOrganisatieIdMedewerkersGet(organisatieId: string): Promise<MedewerkerExOutput> {
        let url_ = this.baseUrl + "/Organisatie/{organisatieId}/Medewerkers";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatieByOrganisatieIdMedewerkersGet(_response);
        });
    }

    protected processOrganisatieByOrganisatieIdMedewerkersGet(response: Response): Promise<MedewerkerExOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerExOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerExOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerExOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerExOutput>(null as any);
    }

    /**
     * Haalt de gegevens van de medewerker met betreffende id op.
     * @param medewerkerId Identificatie van de medewerker
     * @return Success
     */
    medewerkersByMedewerkerIdGet(medewerkerId: string): Promise<MedewerkerOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdGet(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdGet(response: Response): Promise<MedewerkerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een medewerker.
     * @param medewerkerId Identificatie van de medewerker
     * @param medewerker (optional) Gegevens van de medewerker
     * @return Success
     */
    medewerkersByMedewerkerIdPut(medewerkerId: string, medewerker: Medewerker | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medewerker);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdPut(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdPut(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van de medewerker met de betreffende id
     * @param medewerkerId Identificatie van de medewerker
     * @return Success
     */
    medewerkersByMedewerkerIdDelete(medewerkerId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdDelete(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geef de medewerker met het gegeven e-mailadres.
     * @param emailadres (optional) 
     * @return Success
     */
    medewerkersEmailPost(emailadres: string | null | undefined): Promise<MedewerkerOrganisatieOutput> {
        let url_ = this.baseUrl + "/Medewerkers/email?";
        if (emailadres !== undefined && emailadres !== null)
            url_ += "Emailadres=" + encodeURIComponent("" + emailadres) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersEmailPost(_response);
        });
    }

    protected processMedewerkersEmailPost(response: Response): Promise<MedewerkerOrganisatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerOrganisatieOutput>(null as any);
    }

    /**
     * Geeft de medewerkergegevens van de huidige ingelogde gebruiker.
     * @return Success
     */
    medewerkersCurrentGet(): Promise<MedewerkerOrganisatieOutput> {
        let url_ = this.baseUrl + "/Medewerkers/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersCurrentGet(_response);
        });
    }

    protected processMedewerkersCurrentGet(response: Response): Promise<MedewerkerOrganisatieOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOrganisatieOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerOrganisatieOutput>(null as any);
    }

    /**
     * Maakt een nieuwe medewerker aan.
     * @param organisatieId Identificatie van de organisatie
     * @param medewerker (optional) Gegevens van de medewerker
     * @return Success
     */
    organisatiesByOrganisatieIdMedewerkersPost(organisatieId: string, medewerker: Medewerker | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}/Medewerkers";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(medewerker);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesByOrganisatieIdMedewerkersPost(_response);
        });
    }

    protected processOrganisatiesByOrganisatieIdMedewerkersPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Haalt alle vestigingen op van een medewerker.
     * @param medewerkerId Identificatie van de medewerkers
     * @param testRechten (optional) Geeft aan of de klantdossiersrechten op vestiging en organisatie gebruikt moeten worden
     * @return Success
     */
    medewerkersByMedewerkerIdVestigingenGet(medewerkerId: string, testRechten: boolean | null | undefined): Promise<VestigingenOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Vestigingen?";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (testRechten !== undefined && testRechten !== null)
            url_ += "testRechten=" + encodeURIComponent("" + testRechten) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdVestigingenGet(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdVestigingenGet(response: Response): Promise<VestigingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VestigingenOutput>(null as any);
    }

    /**
     * Koppelt vestigingen aan een medewerker.
     * @param medewerkerId Identificatie van de medewerker
     * @param vestigingIdList (optional) Identificatie van de vestiging
     * @return Success
     */
    medewerkersByMedewerkerIdVestigingenPut(medewerkerId: string, vestigingIdList: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Vestigingen";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vestigingIdList);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdVestigingenPut(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdVestigingenPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Koppelt gebruikersgroepen aan een medewerker.
     * @param medewerkerId Identificatie van de medewerker
     * @param gebruikersgroepIdList (optional) Identificatie van de vestiging
     * @return Success
     */
    medewerkersByMedewerkerIdGebruikersgroepenPut(medewerkerId: string, gebruikersgroepIdList: string[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/gebruikersgroepen";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gebruikersgroepIdList);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdGebruikersgroepenPut(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdGebruikersgroepenPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Haalt alle Gebruikersgroepen op van een medewerker.
     * @param medewerkerId Identificatie van de medewerkers
     * @return Success
     */
    medewerkersByMedewerkerIdGebruikersgroepenGet(medewerkerId: string): Promise<GebruikersgroepenOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Gebruikersgroepen";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdGebruikersgroepenGet(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdGebruikersgroepenGet(response: Response): Promise<GebruikersgroepenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GebruikersgroepenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GebruikersgroepenOutput>(null as any);
    }

    /**
     * Koppelt een medewerker aan een vestiging.
     * @param medewerkerId Identificatie van de medewerker
     * @param vestigingId Identificatie van de vestiging
     * @return Success
     */
    medewerkersByMedewerkerIdVestigingenByVestigingIdPost(medewerkerId: string, vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Vestigingen/{vestigingId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdVestigingenByVestigingIdPost(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdVestigingenByVestigingIdPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert koppeling tussen medewerker en vestiging
     * @param medewerkerId Identificatie van de medewerker
     * @param vestigingId Identificatie van de vestiging
     * @return Success
     */
    medewerkersByMedewerkerIdVestigingenByVestigingIdDelete(medewerkerId: string, vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Vestigingen/{vestigingId}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdVestigingenByVestigingIdDelete(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdVestigingenByVestigingIdDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Koppelt een medewerker aan een gebruikersgroep.
     * @param medewerkerId Identificatie van de medewerker
     * @param gebruikersgroepid Identificatie van de gebruikersgroep
     * @return Success
     */
    medewerkersByMedewerkerIdGebruikersgroepenByGebruikersgroepidPost(medewerkerId: string, gebruikersgroepid: string): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Gebruikersgroepen/{gebruikersgroepid}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (gebruikersgroepid === undefined || gebruikersgroepid === null)
            throw new Error("The parameter 'gebruikersgroepid' must be defined.");
        url_ = url_.replace("{gebruikersgroepid}", encodeURIComponent("" + gebruikersgroepid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdGebruikersgroepenByGebruikersgroepidPost(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdGebruikersgroepenByGebruikersgroepidPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert koppeling tussen medewerker en gebruikersgroep
     * @param medewerkerId Identificatie van de medewerker
     * @param gebruikersgroepid Identificatie van de gebruikersgroep
     * @return Success
     */
    medewerkersByMedewerkerIdGebruikersgroepenByGebruikersgroepidDelete(medewerkerId: string, gebruikersgroepid: string): Promise<void> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Gebruikersgroepen/{gebruikersgroepid}";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (gebruikersgroepid === undefined || gebruikersgroepid === null)
            throw new Error("The parameter 'gebruikersgroepid' must be defined.");
        url_ = url_.replace("{gebruikersgroepid}", encodeURIComponent("" + gebruikersgroepid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdGebruikersgroepenByGebruikersgroepidDelete(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdGebruikersgroepenByGebruikersgroepidDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Geeft aan of het gegeven e-mailadres in gebruik is bij een medewerker.
     * @param email Het te controleren e-mailadres
     * @return Success
     */
    medewerkersEmailInGebruikByEmailGet(email: string): Promise<EmailInGebruikOutput> {
        let url_ = this.baseUrl + "/Medewerkers/EmailInGebruik/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersEmailInGebruikByEmailGet(_response);
        });
    }

    protected processMedewerkersEmailInGebruikByEmailGet(response: Response): Promise<EmailInGebruikOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailInGebruikOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailInGebruikOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailInGebruikOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmailInGebruikOutput>(null as any);
    }

    /**
     * Haalt alle rechten op van een medewerker.
     * @param medewerkerId Identificatie van de medewerkers
     * @return Success
     */
    medewerkersByMedewerkerIdRechtenGet(medewerkerId: string): Promise<RechtenOutPut> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Rechten";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdRechtenGet(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdRechtenGet(response: Response): Promise<RechtenOutPut> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RechtenOutPut;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RechtenOutPut;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RechtenOutPut;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RechtenOutPut;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RechtenOutPut>(null as any);
    }

    /**
     * Nodigt een medewerker uit.
     * @param medewerkerId Identificatie van de medewerker
     * @return Success
     */
    medewerkersByMedewerkerIdUitnodigingPost(medewerkerId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Uitnodiging";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdUitnodigingPost(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdUitnodigingPost(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haalt de Organisaties op met hoofdvestiging en LicentieOvereenkomsten.
     * @return Success
     */
    organisatiesGet(): Promise<OrganisatiesExOutput> {
        let url_ = this.baseUrl + "/Organisaties";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesGet(_response);
        });
    }

    protected processOrganisatiesGet(response: Response): Promise<OrganisatiesExOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesExOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesExOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesExOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisatiesExOutput>(null as any);
    }

    /**
     * Maakt een nieuwe organisatie aan.
     * @param organisatieEx (optional) 
     * @return Success
     */
    organisatiesPost(organisatieEx: OrganisatieEx | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Organisaties";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(organisatieEx);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesPost(_response);
        });
    }

    protected processOrganisatiesPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Haalt de gegevens van de organisatie met de betreffende id op.
     * @param organisatieId Identificatie van de organisatie
     * @return Success
     */
    organisatiesByOrganisatieIdGet(organisatieId: string): Promise<OrganisatiesOutput> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesByOrganisatieIdGet(_response);
        });
    }

    protected processOrganisatiesByOrganisatieIdGet(response: Response): Promise<OrganisatiesOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisatiesOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisatiesOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een organisatie.
     * @param organisatieId De identificatie van de organisatie
     * @param model (optional) De te wijzigen gegevens van de organisatie
     * @return Success
     */
    organisatiesByOrganisatieIdPut(organisatieId: string, model: Organisatie | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesByOrganisatieIdPut(_response);
        });
    }

    protected processOrganisatiesByOrganisatieIdPut(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van de organisatie met het betreffende id.
     * @param organisatieId De identificatie van de organisatie
     * @return Success
     */
    organisatiesByOrganisatieIdDelete(organisatieId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesByOrganisatieIdDelete(_response);
        });
    }

    protected processOrganisatiesByOrganisatieIdDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft aan of het gegeven KvK-nummer in gebruik is bij een organisatie met een actieve licentieovereenkomst.
     * @param kvKnummer Het (unieke) KvK-nummer van de organisatie
     * @return Success
     */
    organisatiesKvKnummerInGebruikByKvKnummerGet(kvKnummer: string): Promise<KvKnummerInGebruikOutput> {
        let url_ = this.baseUrl + "/Organisaties/KvKnummerInGebruik/{kvKnummer}";
        if (kvKnummer === undefined || kvKnummer === null)
            throw new Error("The parameter 'kvKnummer' must be defined.");
        url_ = url_.replace("{kvKnummer}", encodeURIComponent("" + kvKnummer));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesKvKnummerInGebruikByKvKnummerGet(_response);
        });
    }

    protected processOrganisatiesKvKnummerInGebruikByKvKnummerGet(response: Response): Promise<KvKnummerInGebruikOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KvKnummerInGebruikOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KvKnummerInGebruikOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KvKnummerInGebruikOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KvKnummerInGebruikOutput>(null as any);
    }

    /**
     * Verwijdert het organisatielogo.
     * @return Success
     */
    organisatiesByOrganisatieIdLogoDelete(organisatieId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Organisaties/{organisatieId}/Logo";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesByOrganisatieIdLogoDelete(_response);
        });
    }

    protected processOrganisatiesByOrganisatieIdLogoDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Zoeken binnen de organisaties
     * @param soort Criterium waarop gezocht wordt Organisatienaam = 0, Postcode = 1, Plaats = 2, KvkNummer = 3
     * @param q (optional) De zoekstring
     * @return Success
     */
    organisatiesZoekenBySoortGet(soort: Soort, q: string | null | undefined): Promise<ZoekresultaatOutput> {
        let url_ = this.baseUrl + "/Organisaties/Zoeken/{soort}?";
        if (soort === undefined || soort === null)
            throw new Error("The parameter 'soort' must be defined.");
        url_ = url_.replace("{soort}", encodeURIComponent("" + soort));
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatiesZoekenBySoortGet(_response);
        });
    }

    protected processOrganisatiesZoekenBySoortGet(response: Response): Promise<ZoekresultaatOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatOutput;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ZoekresultaatOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ZoekresultaatOutput>(null as any);
    }

    /**
     * Haalt de producten op.
     * @return Success
     */
    productenGet(): Promise<ProductenOutput> {
        let url_ = this.baseUrl + "/Producten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenGet(_response);
        });
    }

    protected processProductenGet(response: Response): Promise<ProductenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenOutput>(null as any);
    }

    /**
     * Maakt een nieuw product aan.
     * @param product (optional) De gegevens van de nieuwe product
     * @return Success
     */
    productenPost(product: Product | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Producten";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(product);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenPost(_response);
        });
    }

    protected processProductenPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Haalt de gegevens van het product met de betreffende id op.
     * @param productId Identificatie van het product
     * @return Success
     */
    productenByProductIdGet(productId: string): Promise<ProductenOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenByProductIdGet(_response);
        });
    }

    protected processProductenByProductIdGet(response: Response): Promise<ProductenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een product.
     * @param productId De identificatie van het product
     * @param model (optional) De te wijzigen gegevens van het product
     * @return Success
     */
    productenByProductIdPut(productId: string, model: Product | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Producten/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenByProductIdPut(_response);
        });
    }

    protected processProductenByProductIdPut(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert het product met het betreffende id.
     * @param productId De identificatie van het product
     * @return Success
     */
    productenByProductIdDelete(productId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Producten/{productId}";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenByProductIdDelete(_response);
        });
    }

    protected processProductenByProductIdDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haalt de gegevens van het product met de betreffende id op.
     * @param productCode Identificatie van het product
     * @return Success
     */
    productenGetProductByCodeByProductCodeGet(productCode: string): Promise<ProductenOutput> {
        let url_ = this.baseUrl + "/Producten/GetProductByCode/{productCode}";
        if (productCode === undefined || productCode === null)
            throw new Error("The parameter 'productCode' must be defined.");
        url_ = url_.replace("{productCode}", encodeURIComponent("" + productCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenGetProductByCodeByProductCodeGet(_response);
        });
    }

    protected processProductenGetProductByCodeByProductCodeGet(response: Response): Promise<ProductenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductenOutput>(null as any);
    }

    /**
     * Geeft de productonderdelen van een product.
     * @param productId Unieke identificatie van het product
     * @return Success
     */
    productenByProductIdProductonderdelenGet(productId: string): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}/Productonderdelen";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenByProductIdProductonderdelenGet(_response);
        });
    }

    protected processProductenByProductIdProductonderdelenGet(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Voegt een productonderdeel toe aan een product.
     * @param productId Unieke identificatie van een product
     * @param productonderdeel (optional) Gegevens van het productonderdeel
     * @return Success
     */
    productenByProductIdProductonderdelenPost(productId: string, productonderdeel: Productonderdeel | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}/Productonderdelen";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productonderdeel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenByProductIdProductonderdelenPost(_response);
        });
    }

    protected processProductenByProductIdProductonderdelenPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Geeft de actieve productonderdelen van een medewerker en product.
     * @param medewerkerId Unieke identificatie van het medewerker
     * @param productId Unieke identificatie van het product
     * @return Success
     */
    medewerkersByMedewerkerIdProductenByProductIdProductonderdelenGet(medewerkerId: string, productId: string): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Medewerkers/{medewerkerId}/Producten/{productId}/Productonderdelen";
        if (medewerkerId === undefined || medewerkerId === null)
            throw new Error("The parameter 'medewerkerId' must be defined.");
        url_ = url_.replace("{medewerkerId}", encodeURIComponent("" + medewerkerId));
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMedewerkersByMedewerkerIdProductenByProductIdProductonderdelenGet(_response);
        });
    }

    protected processMedewerkersByMedewerkerIdProductenByProductIdProductonderdelenGet(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Geeft de gegevens van een productonderdeel
     * @param productId (optional) 
     * @param code (optional) 
     * @return Success
     */
    productonderdelenGetByCodeGet(productId: string | null | undefined, code: string | null | undefined): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Productonderdelen/GetByCode?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        if (code !== undefined && code !== null)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelenGetByCodeGet(_response);
        });
    }

    protected processProductonderdelenGetByCodeGet(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Geeft de gegevens van een productonderdeel.
     * @param productonderdeelId Unieke identificatie van het productonderdeel
     * @return Success
     */
    productonderdelenByProductonderdeelIdGet(productonderdeelId: string): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelenByProductonderdeelIdGet(_response);
        });
    }

    protected processProductonderdelenByProductonderdeelIdGet(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Werkt de gegevens van het productonderdeel bij.
     * @param productonderdeelId Unieke identificatie van het productonderdeel
     * @param productonderdeel (optional) De gegevens van het productonderdeel
     * @return Success
     */
    productonderdelenByProductonderdeelIdPut(productonderdeelId: string, productonderdeel: Productonderdeel | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productonderdeel);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelenByProductonderdeelIdPut(_response);
        });
    }

    protected processProductonderdelenByProductonderdeelIdPut(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert een productonderdeel.
     * @param productonderdeelId Unieke identificatie van het productonderdeel
     * @return Success
     */
    productonderdelenByProductonderdeelIdDelete(productonderdeelId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelenByProductonderdeelIdDelete(_response);
        });
    }

    protected processProductonderdelenByProductonderdeelIdDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft de gegevens van alle productonderdelen.
     * @return Success
     */
    productonderdelenGet(): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Productonderdelen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelenGet(_response);
        });
    }

    protected processProductonderdelenGet(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Geeft de gegevens van een of meerdere productonderdelen.
     * @param productonderdeelIds (optional) Lijst met unieke identificatie van productonderdelen
     * @return Success
     */
    productonderdelenGetByProductonderdeelIdsGet(productonderdeelIds: string[] | null | undefined): Promise<ProductonderdelenOutput> {
        let url_ = this.baseUrl + "/Productonderdelen/GetByProductonderdeelIds?";
        if (productonderdeelIds !== undefined && productonderdeelIds !== null)
            productonderdeelIds && productonderdeelIds.forEach(item => { url_ += "productonderdeelIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelenGetByProductonderdeelIdsGet(_response);
        });
    }

    protected processProductonderdelenGetByProductonderdeelIdsGet(response: Response): Promise<ProductonderdelenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductonderdelenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductonderdelenOutput>(null as any);
    }

    /**
     * Koppelt een productonderdeel een aan gebruikersgroep.
     * @param productonderdeelId (optional) 
     * @return Success
     */
    productonderdelenKoppelProductonderdeelAanGebruikersgroepenPost(productonderdeelId: string | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productonderdelen/KoppelProductonderdeelAanGebruikersgroepen?";
        if (productonderdeelId !== undefined && productonderdeelId !== null)
            url_ += "productonderdeelId=" + encodeURIComponent("" + productonderdeelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelenKoppelProductonderdeelAanGebruikersgroepenPost(_response);
        });
    }

    protected processProductonderdelenKoppelProductonderdeelAanGebruikersgroepenPost(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Ontkoppelt een gebruikersgroep van een productonderdeel.
     * @param productonderdeelId (optional) 
     * @return Success
     */
    productonderdelenOntkoppelGebruikersgroepenVanProductonderdeelPost(productonderdeelId: string | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productonderdelen/OntkoppelGebruikersgroepenVanProductonderdeel?";
        if (productonderdeelId !== undefined && productonderdeelId !== null)
            url_ += "productonderdeelId=" + encodeURIComponent("" + productonderdeelId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductonderdelenOntkoppelGebruikersgroepenVanProductonderdeelPost(_response);
        });
    }

    protected processProductonderdelenOntkoppelGebruikersgroepenVanProductonderdeelPost(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haalt de productsamenstellingen van het product met betreffende id op.
     * @param productId Unieke identificatie van het product
     * @return Success
     */
    productenByProductIdProductsamenstellingenGet(productId: string): Promise<ProductsamenstellingenOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}/Productsamenstellingen";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenByProductIdProductsamenstellingenGet(_response);
        });
    }

    protected processProductenByProductIdProductsamenstellingenGet(response: Response): Promise<ProductsamenstellingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductsamenstellingenOutput>(null as any);
    }

    /**
     * Maakt een nieuwe productsamenstelling aan voor een product.
     * @param productId Unieke identificatie van het product
     * @param productsamenstelling (optional) De gegevens van de nieuwe productsamenstelling
     * @return Success
     */
    productenByProductIdProductsamenstellingenPost(productId: string, productsamenstelling: Productsamenstelling | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Producten/{productId}/Productsamenstellingen";
        if (productId === undefined || productId === null)
            throw new Error("The parameter 'productId' must be defined.");
        url_ = url_.replace("{productId}", encodeURIComponent("" + productId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productsamenstelling);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductenByProductIdProductsamenstellingenPost(_response);
        });
    }

    protected processProductenByProductIdProductsamenstellingenPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Haalt de gegevens van de productsamenstelling met betreffende id op.
     * @param productsamenstellingId Unieke identificatie van de productsamenstelling
     * @return Success
     */
    productsamenstellingenByProductsamenstellingIdGet(productsamenstellingId: string): Promise<ProductsamenstellingenOutput> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}";
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstellingenByProductsamenstellingIdGet(_response);
        });
    }

    protected processProductsamenstellingenByProductsamenstellingIdGet(response: Response): Promise<ProductsamenstellingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProductsamenstellingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductsamenstellingenOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een Productsamenstelling.
     * @param productsamenstellingId De identificatie van de Productsamenstelling
     * @param productsamenstelling (optional) De te wijzigen gegevens van het Productsamenstelling
     * @return Success
     */
    productsamenstellingenByProductsamenstellingIdPut(productsamenstellingId: string, productsamenstelling: Productsamenstelling | null | undefined): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}";
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productsamenstelling);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstellingenByProductsamenstellingIdPut(_response);
        });
    }

    protected processProductsamenstellingenByProductsamenstellingIdPut(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Verwijdert de gegevens van de Productsamenstelling met het betreffende id.
     * @param productsamenstellingId De identificatie van het Productsamenstelling
     * @return Success
     */
    productsamenstellingenByProductsamenstellingIdDelete(productsamenstellingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}";
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstellingenByProductsamenstellingIdDelete(_response);
        });
    }

    protected processProductsamenstellingenByProductsamenstellingIdDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Koppelt een productonderdeel aan een productsamenstelling.
     * @return Success
     */
    productsamenstellingenByProductsamenstellingIdProductonderdelenByProductonderdeelIdPost(productonderdeelId: string, productsamenstellingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstellingenByProductsamenstellingIdProductonderdelenByProductonderdeelIdPost(_response);
        });
    }

    protected processProductsamenstellingenByProductsamenstellingIdProductonderdelenByProductonderdeelIdPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Ontkoppelt een productonderdeel van een samenstelling.
     * @return Success
     */
    productsamenstellingenByProductsamenstellingIdProductonderdelenByProductonderdeelIdDelete(productonderdeelId: string, productsamenstellingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Productsamenstellingen/{productsamenstellingId}/Productonderdelen/{productonderdeelId}";
        if (productonderdeelId === undefined || productonderdeelId === null)
            throw new Error("The parameter 'productonderdeelId' must be defined.");
        url_ = url_.replace("{productonderdeelId}", encodeURIComponent("" + productonderdeelId));
        if (productsamenstellingId === undefined || productsamenstellingId === null)
            throw new Error("The parameter 'productsamenstellingId' must be defined.");
        url_ = url_.replace("{productsamenstellingId}", encodeURIComponent("" + productsamenstellingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProductsamenstellingenByProductsamenstellingIdProductonderdelenByProductonderdeelIdDelete(_response);
        });
    }

    protected processProductsamenstellingenByProductsamenstellingIdProductonderdelenByProductonderdeelIdDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Geeft de gegevens voor het registratiescherm voor een nieuwe gebruiker.
     * @return Success
     */
    registratieKantoorGet(): Promise<RegistratieKantoorOutput> {
        let url_ = this.baseUrl + "/RegistratieKantoor";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistratieKantoorGet(_response);
        });
    }

    protected processRegistratieKantoorGet(response: Response): Promise<RegistratieKantoorOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistratieKantoorOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistratieKantoorOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistratieKantoorOutput>(null as any);
    }

    /**
     * Verwerkt de inhoud van het registratieKantoor-scherm tot een registratie.
     * @param overeenkomst (optional) De gegevens van het registratiescherm
     * @return Success
     */
    registratieKantoorPost(overeenkomst: Overeenkomst | null | undefined): Promise<RegistreerkantoorSubscriptionOutput> {
        let url_ = this.baseUrl + "/RegistratieKantoor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(overeenkomst);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistratieKantoorPost(_response);
        });
    }

    protected processRegistratieKantoorPost(response: Response): Promise<RegistreerkantoorSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistreerkantoorSubscriptionOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistreerkantoorSubscriptionOutput>(null as any);
    }

    /**
     * Geeft de gegevens voor het registratiescherm voor een bestaande gebruiker van Adviesbox Classic.
     * @param klantcode De klantcode van de gebruiker uit Adviesbox Classic
     * @param sessietoken Het token dat de gebruiker met Adviesbox Classic heeft opgehaald
     * @return Success
     */
    registratieKantoorBestaandGet(klantcode: string, sessietoken: string): Promise<RegistratieKantoorOutput> {
        let url_ = this.baseUrl + "/RegistratieKantoor/Bestaand?";
        if (klantcode === undefined || klantcode === null)
            throw new Error("The parameter 'klantcode' must be defined and cannot be null.");
        else
            url_ += "klantcode=" + encodeURIComponent("" + klantcode) + "&";
        if (sessietoken === undefined || sessietoken === null)
            throw new Error("The parameter 'sessietoken' must be defined and cannot be null.");
        else
            url_ += "sessietoken=" + encodeURIComponent("" + sessietoken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistratieKantoorBestaandGet(_response);
        });
    }

    protected processRegistratieKantoorBestaandGet(response: Response): Promise<RegistratieKantoorOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistratieKantoorOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RegistratieKantoorOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegistratieKantoorOutput>(null as any);
    }

    /**
     * Start het genereren van de overeenkomst.
     * @param registratieKantoor (optional) Gegevens die ingevuld zijn voor de registratie
     * @return Success
     */
    registratieKantoorOvereenkomstPost(registratieKantoor: RegistratieKantoor | null | undefined): Promise<OvereenkomstSubscriptionOutput> {
        let url_ = this.baseUrl + "/RegistratieKantoor/Overeenkomst";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registratieKantoor);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistratieKantoorOvereenkomstPost(_response);
        });
    }

    protected processRegistratieKantoorOvereenkomstPost(response: Response): Promise<OvereenkomstSubscriptionOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OvereenkomstSubscriptionOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OvereenkomstSubscriptionOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OvereenkomstSubscriptionOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OvereenkomstSubscriptionOutput>(null as any);
    }

    /**
     * Registeren.
     * @param productId (optional) 
     * @param registrerenModel (optional) 
     * @return Success
     */
    registrerenPost(productId: string | null | undefined, registrerenModel: Registreren | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Registreren?";
        if (productId !== undefined && productId !== null)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(registrerenModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegistrerenPost(_response);
        });
    }

    protected processRegistrerenPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Geeft versie informatie van de applicatie.
     * @return De gevraagde versieinfo kon worden opgehaald en is beschikbaar in de uitvoer.
     */
    versionInfoGet(): Promise<VersionInfo> {
        let url_ = this.baseUrl + "/VersionInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVersionInfoGet(_response);
        });
    }

    protected processVersionInfoGet(response: Response): Promise<VersionInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VersionInfo;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BadRequestResult;
            return throwException("Er is iets foutgegaan tijdens het ophalen van de versieinfo. Kijken in de Messages van de uitvoer voor het probleem.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VersionInfo>(null as any);
    }

    /**
     * Geeft de foutcodes die in deze Web API kunnen ontstaan.
     * @return Success
     */
    versionInfoFoutCodesGet(): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/VersionInfo/FoutCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVersionInfoFoutCodesGet(_response);
        });
    }

    protected processVersionInfoFoutCodesGet(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Geeft de vestigingen van een bepaalde organisatie.
     * @return Success
     */
    organisatieByOrganisatieIdVestigingenGet(organisatieId: string): Promise<VestigingenOutput> {
        let url_ = this.baseUrl + "/Organisatie/{organisatieId}/Vestigingen";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatieByOrganisatieIdVestigingenGet(_response);
        });
    }

    protected processOrganisatieByOrganisatieIdVestigingenGet(response: Response): Promise<VestigingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VestigingenOutput>(null as any);
    }

    /**
     * Maakt een vestiging aan onder een bepaalde organisatie.
     * @param organisatieId De identificatie van de organisatie
     * @param model (optional) De gegevens van de vestiging
     * @return Success
     */
    organisatieByOrganisatieIdVestigingenPost(organisatieId: string, model: Vestiging | null | undefined): Promise<NewOutput> {
        let url_ = this.baseUrl + "/Organisatie/{organisatieId}/Vestigingen";
        if (organisatieId === undefined || organisatieId === null)
            throw new Error("The parameter 'organisatieId' must be defined.");
        url_ = url_.replace("{organisatieId}", encodeURIComponent("" + organisatieId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOrganisatieByOrganisatieIdVestigingenPost(_response);
        });
    }

    protected processOrganisatieByOrganisatieIdVestigingenPost(response: Response): Promise<NewOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewOutput>(null as any);
    }

    /**
     * Geeft de (basisgegevens van de) vestiging met een bepaalde identificatie.
     * @return Success
     */
    vestigingenByVestigingIdGet(vestigingId: string): Promise<VestigingenOutput> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingenByVestigingIdGet(_response);
        });
    }

    protected processVestigingenByVestigingIdGet(response: Response): Promise<VestigingenOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VestigingenOutput>(null as any);
    }

    /**
     * Wijzigt de gegevens van een vestiging.
     * @param vestigingId De identificatie van de vestiging
     * @param model (optional) De nieuwe gegevens van de vestiging
     * @return Success
     */
    vestigingenByVestigingIdPut(vestigingId: string, model: Vestiging | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingenByVestigingIdPut(_response);
        });
    }

    protected processVestigingenByVestigingIdPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert de gegevens van een vestiging.
     * @param vestigingId Identificatie van de vestiging
     * @return Success
     */
    vestigingenByVestigingIdDelete(vestigingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingenByVestigingIdDelete(_response);
        });
    }

    protected processVestigingenByVestigingIdDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Maakt de gegeven vestiging de hoofdvestiging van de organisatie waaronder de vestiging valt.
     * @param vestigingId De identificatie van de vestiging
     * @return Success
     */
    vestigingenByVestigingIdHoofdvestigingPut(vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Hoofdvestiging";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingenByVestigingIdHoofdvestigingPut(_response);
        });
    }

    protected processVestigingenByVestigingIdHoofdvestigingPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Verwijdert het postadres van de vestiging.
     * @param vestigingId Identificatie van de vestiging
     * @return Success
     */
    vestigingenByVestigingIdPostadresDelete(vestigingId: string): Promise<void> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Postadres";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingenByVestigingIdPostadresDelete(_response);
        });
    }

    protected processVestigingenByVestigingIdPostadresDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VestigingenOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Kent de connectionstring van de hoofdvestiging opnieuw toe aan de vestiging.
     * @return Success
     */
    vestigingenByVestigingIdConnectionPut(vestigingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Connection";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingenByVestigingIdConnectionPut(_response);
        });
    }

    protected processVestigingenByVestigingIdConnectionPut(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            let result204: any = null;
            result204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result204;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }

    /**
     * Haal de medewerkers van een vestiging op.
     * @return Success
     */
    vestigingenByVestigingIdMedewerkersGet(vestigingId: string): Promise<MedewerkerOutput> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Medewerkers";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingenByVestigingIdMedewerkersGet(_response);
        });
    }

    protected processVestigingenByVestigingIdMedewerkersGet(response: Response): Promise<MedewerkerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MedewerkerOutput;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedewerkerOutput>(null as any);
    }

    /**
     * Verwijder alle klantdossiers van een vestiging
     * @param vestigingId Id van de vestiging waarvan de klantdossiers verwijderd moeten worden
     * @return Success
     */
    vestigingenByVestigingIdKlantdossiersDelete(vestigingId: string): Promise<ValidationResultsModel> {
        let url_ = this.baseUrl + "/Vestigingen/{vestigingId}/Klantdossiers";
        if (vestigingId === undefined || vestigingId === null)
            throw new Error("The parameter 'vestigingId' must be defined.");
        url_ = url_.replace("{vestigingId}", encodeURIComponent("" + vestigingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processVestigingenByVestigingIdKlantdossiersDelete(_response);
        });
    }

    protected processVestigingenByVestigingIdKlantdossiersDelete(response: Response): Promise<ValidationResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationResultsModel;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidationResultsModel>(null as any);
    }
}

/** Uitvoer van een lijst met gebruikersgroepen (incl. key). */
export interface GebruikersgroepenOutput {
    /** Lijst met gebruikersgroepen (incl. key) */
    gebruikersgroepen: { [key: string]: Gebruikersgroep; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van een gebruikersgroep. */
export interface Gebruikersgroep {
    /** Naam van de Gebruikersgroep */
    naam: string;
    /** Beschrijving van de gebruikersgroep */
    beschrijving: string | null;
    /** ID van de organisatie */
    organisatieId: string | null;
    /** Gekoppelde product onderdelen */
    productonderdelen: string[] | null;
}

export interface ValidationResultModel {
    code: string | null;
    target: string | null;
    message: string | null;
}

export interface ValidationResultsModel {
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

export interface NewOutput {
    id: string | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de output van het opvragen van HDN nodenummers. */
export interface HdnNodenummersOutput {
    /** Collectie met HDN nodenummers met bijbehorend ID */
    hdnNodenummers: { [key: string]: HdnNodenummer; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van een HDN nodenummer. */
export interface HdnNodenummer {
    /** Nummer van de HDN node (kan voorloopnullen bevatten) */
    nodenummer: string;
    /** Indicatie dat het nodenummer geactiveerd is bij HDN */
    readonly geactiveerd: boolean | null;
    /** Geeft aan voor welke entiteit(en) het HDN nodenummer geldig is Vestiging = 1, Organisatie = 2 */
    geldigVoor: HdnNodenummerGeldigVoor | null;
    /** Vestigingen waarvoor het HDN nodenummer geldig is */
    vestigingen: HdnNodenummerVestiging[] | null;
}

/** Bevat gegevens van een vestiging waarvoor een HDN nodenummer geldig is. */
export interface HdnNodenummerVestiging {
    /** Het Id van de vestiging. */
    vestigingId: string | null;
    /** De naam van de vestiging */
    readonly naam: string | null;
}

/** Output van licentieovereenkomsten. */
export interface LicentieovereenkomstenOutput {
    /** Collectie met licentieovereenkomsten. */
    licentieovereenkomsten: { [key: string]: Licentieovereenkomst; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een licentieovereenkomst. */
export interface Licentieovereenkomst {
    /** Is de licentieovereenkomst geblokkeerd, buiten andere regels om (bv. bij wanbetaling) */
    isGeblokkeerd: boolean | null;
    /** Is de licentieovereenkomst actief */
    isActief: boolean | null;
    /** Begindatum van de overeenkomst */
    begindatum: string;
    /** Einddatum van de overeenkomst */
    einddatum: string | null;
    /** Datum van opzegging */
    opzegdatum: string | null;
    /** De opzegtermijn voor deze licentieovereenkomst */
    opzegtermijn: number | null;
    /** De licentiesoort van de licentieovereenkomst Betaald = 0, Proef = 1, Intern = 2 */
    licentiesoort: LicentieovereenkomstLicentiesoort | null;
    /** IBAN van de rekening */
    iban: string | null;
    /** E-mail adres */
    emailFinancieelGemachtigde: string | null;
    /** Betaalwijze Incasso = 0, Factuur = 1 */
    betaalwijze: LicentieovereenkomstBetaalwijze | null;
    /** ID van de gekoppelde organisatie */
    organisatieId: string | null;
    /** ID van het gekoppelde product */
    productId: string | null;
    /** Naam van het gekoppelde product */
    productNaam: string | null;
    /** Contractcode */
    contractId: string | null;
    /** Duur van de proefperiode in dagen */
    duurProefperiode: number | null;
    /** Eerste factuurdatum */
    eersteFactuurDatum: string | null;
    /** Ten behoeve van opslag T.a.v. */
    factuurNaamPersoon: string | null;
    /** Het adres waar de factuur naartoe gestuurd moet worden */
    factuurAdres: AdresInput | null;
    /** Kostenplaats van de factuur */
    kostenplaats: string | null;
    /** Vrije tekst op de factuur */
    vrijeTekst: string | null;
    /** Documenten behorende bij de overeenkomst */
    licentieovereenkomstDocumenten: { [key: string]: LicentieovereenkomstDocument; } | null;
}

/** De gegevens van een adres. */
export interface AdresInput {
    /** De straatnaam */
    straatnaam: string;
    /** Het huisnummer */
    huisnummer: string;
    /** Toevoeging op het huisnummer */
    toevoeging: string | null;
    /** De postcode */
    postcode: string;
    /** Land (identificatie) */
    landCode: string;
    /** Het land */
    land: string;
    /** De plaats */
    plaats: string;
}

/** Document behorende bij een licentieovereenkomst. */
export interface LicentieovereenkomstDocument {
    /** id van dit document */
    licentieovereenkomstDocumentId: string | null;
    /** De naam/titel van dit licentieovereenkomst document. */
    naam: string | null;
    /** De bestandsnaam. */
    bestandsnaam: string | null;
    /** Datum tijd van aanmaken document. */
    aanmaakDatumTijd: string | null;
    /** Naam van het bestand */
    url: string | null;
}

/** Gegevens van een licentie. */
export interface LicentiesOutput {
    /** Lijst met licenties en hun key */
    licenties: { [key: string]: Licentie; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een licentie. */
export interface Licentie {
    /** Unieke identificatie van de licentie binnen het platform. */
    platformId: string | null;
    /** ID van de gekoppelde medewerker */
    medewerkerId: string | null;
    /** ID van het gekoppelde productsamenstelling */
    productsamenstellingId: string | null;
    /** Naam van de productsamenstelling */
    productsamenstellingNaam: string | null;
    /** ID van de gekoppelde licentieovereenkomst */
    licentieovereenkomstId: string | null;
}

/** Uitvoer van een lijst met licentie gegevens van een productsamenstelling */
export interface LicentiesDetailsOutput {
    /** De lijst met lecentiegegevens van een productsamenstelling */
    productsamenstellingLicenties: { [key: string]: LicentiesDetails; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Licentie gegevens van een productsamenstelling */
export interface LicentiesDetails {
    /** Id van de licentie */
    licentieId: string | null;
    /** Id van de medewerker */
    medewerkerId: string | null;
    /** Gegevens van de medewerker */
    medewerker: Medewerker | null;
    /** Opsomming van de vestigingen die aan de medewerker gekoppeld zijn */
    vestiging: string | null;
    /** Einddatum van de licentie */
    einddatum: string | null;
}

/** Bevat gegevens van een medewerker. */
export interface Medewerker {
    /** Voornaam */
    voornaam: string | null;
    /** Tussenvoegsels */
    tussenvoegsels: string | null;
    /** Achternaam */
    achternaam: string;
    /** Roepnaam */
    roepnaam: string | null;
    /** Voorletters */
    voorletters: string;
    /** Geslacht Man = 0, Vrouw = 1, Neutraal = 2 */
    geslacht: MedewerkerGeslacht | null;
    /** Telefoonnummer */
    telefoon: string | null;
    /** Telefoonnummer werk */
    telefoonWerk: string | null;
    /** Mobiele nummer */
    telefoonMobiel: string | null;
    /** E-mail adres */
    email: string;
    /** Functie */
    functie: string | null;
    /** PlatformId */
    platformId: string | null;
    /** Klantcode */
    klantId: string | null;
    /** Actief */
    isActief: boolean | null;
    /** Rechten op de klantdossiers van de vestiging(en) waar de medewerker aan verbonden is Geen = 0, AlleenLezen = 1, LezenEnSchrijven = 2 */
    klantdossierRechtenVestigingen: MedewerkerKlantdossierRechtenVestigingen | null;
    /** Rechten op de klantdossiers van de organisatie waar de medewerker aan verbonden is Geen = 0, AlleenLezen = 1, LezenEnSchrijven = 2 */
    klantdossierRechtenOrganisatie: MedewerkerKlantdossierRechtenOrganisatie | null;
}

/** Output voor MedewerkerEx */
export interface MedewerkerExOutput {
    /** Unieke identificatie van een medewerker */
    medewerkers: { [key: string]: MedewerkerEx; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Medewerker met vestigingen */
export interface MedewerkerEx {
    /** Vestigingen */
    vestigingen: string[] | null;
    /** Gebruikersgroepen */
    gebruikersgroepen: string[] | null;
    /** Productsamenstelling van de licentie */
    productsamenstellingId: string | null;
    /** Naam van de productsamenstelling */
    productsamenstelling: string | null;
    /** Voornaam */
    voornaam: string | null;
    /** Tussenvoegsels */
    tussenvoegsels: string | null;
    /** Achternaam */
    achternaam: string;
    /** Roepnaam */
    roepnaam: string | null;
    /** Voorletters */
    voorletters: string;
    /** Geslacht Man = 0, Vrouw = 1, Neutraal = 2 */
    geslacht: MedewerkerExGeslacht | null;
    /** Telefoonnummer */
    telefoon: string | null;
    /** Telefoonnummer werk */
    telefoonWerk: string | null;
    /** Mobiele nummer */
    telefoonMobiel: string | null;
    /** E-mail adres */
    email: string;
    /** Functie */
    functie: string | null;
    /** PlatformId */
    platformId: string | null;
    /** Klantcode */
    klantId: string | null;
    /** Actief */
    isActief: boolean | null;
    /** Rechten op de klantdossiers van de vestiging(en) waar de medewerker aan verbonden is Geen = 0, AlleenLezen = 1, LezenEnSchrijven = 2 */
    klantdossierRechtenVestigingen: MedewerkerExKlantdossierRechtenVestigingen | null;
    /** Rechten op de klantdossiers van de organisatie waar de medewerker aan verbonden is Geen = 0, AlleenLezen = 1, LezenEnSchrijven = 2 */
    klantdossierRechtenOrganisatie: MedewerkerExKlantdossierRechtenOrganisatie | null;
}

/** Output voor Medewerker */
export interface MedewerkerOutput {
    /** Unieke identificatie van een medewerker */
    medewerkers: { [key: string]: Medewerker; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een medewerker en de organisatie waaraan de medewerker gekoppeld is. */
export interface MedewerkerOrganisatieOutput {
    /** Unieke identificatie van de medewerker. */
    medewerkerId: string | null;
    /** Gegevens van de medewerker. */
    medewerker: Medewerker | null;
    /** Unieke identificatie van de organisatie. */
    organisatieId: string | null;
    /** Naam van de organisatie. */
    readonly organisatieNaam: string | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De uitvoer van een opvraging van een lijst met vestigingen. */
export interface VestigingenOutput {
    /** De gevonden vestigingen */
    vestigingen: { [key: string]: Vestiging; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van de vestiging. */
export interface Vestiging {
    /** De naam van de vestiging */
    naam: string;
    /** Het bezoekadres van de vestiging */
    bezoekadres: AdresInput;
    /** Het postadres van de vestiging */
    postadres: AdresInput | null;
    /** Het e-mailadres van (de contactpersoon van) de vestiging */
    emailadres: string;
    /** Het telefoonnummer van de vestiging */
    telefoonnummer: string;
    /** Unieke identificatie van de vestiging binnen het platform */
    platformId: string | null;
    /** Het AFM-registratienummer */
    afmRegistratienummer: string;
    /** Geeft aan of dit de hoofdvestiging is */
    isHoofdvestiging: boolean | null;
    /** Geeft bijbehorende organisatieId aan */
    organisatieId: string | null;
}

/** Het resultaat van een de vraag of een e-mailadres in gebruik is. */
export interface EmailInGebruikOutput {
    /** Indicatie dat het e-mailadres in gebruik is bij een medewerker. */
    inGebruik: boolean | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Output voor het opvragen van rechten van een medewerker. */
export interface RechtenOutPut {
    /** De rechten van een medewerker */
    rechten: string[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat de output van het opvragen van (extended) organisaties. */
export interface OrganisatiesExOutput {
    /** Lijst met organisaties en hun key */
    organisaties: { [key: string]: OrganisatieEx; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Organisatie en vestiging voor het toevoegen van een nieuwe organisatie (met hoofdvestiging). */
export interface OrganisatieEx {
    /** Vestiging */
    vestiging: Vestiging | null;
    /** Licentieovereenkomsten */
    licentieovereenkomsten: Licentieovereenkomst[] | null;
    /** Naam van de organisatie */
    naam: string;
    /** Unieke identificatie van de organisatie binnen het platform */
    platformId: string | null;
    /** Het KvK-nummer van de organisatie */
    kvKnummer: string | null;
    /** Logo van de organisatie */
    logo: string | null;
    /** IBAN voor incasso */
    iban: string | null;
    /** Het Id van de organisatie. */
    organisatieId: string | null;
}

/** Bevat de output van het opvragen van organisaties. */
export interface OrganisatiesOutput {
    /** Lijst met organisaties en hun key */
    organisaties: { [key: string]: Organisatie; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Gegevens van een organisatie. */
export interface Organisatie {
    /** Naam van de organisatie */
    naam: string;
    /** Unieke identificatie van de organisatie binnen het platform */
    platformId: string | null;
    /** Het KvK-nummer van de organisatie */
    kvKnummer: string | null;
    /** Logo van de organisatie */
    logo: string | null;
    /** IBAN voor incasso */
    iban: string | null;
    /** Het Id van de organisatie. */
    organisatieId: string | null;
}

/** Het resultaat van een de vraag of een KvK-nummer in gebruik is. */
export interface KvKnummerInGebruikOutput {
    /** Indicatie dat het KvK-nummer in gebruik is bij een organisatie met een actieve licentieovereenkomst */
    inGebruik: boolean | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Het resultaat van een zoekopdracht */
export interface ZoekresultaatOutput {
    /** De zoekresultaten */
    readonly zoekresultaten: Zoekresultaat[] | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Een zoekresultaat */
export interface Zoekresultaat {
    /** De gegevens van de gevonden organisatie */
    readonly organisatie: Organisatie | null;
    /** De hoofdvestiging van de organisatie */
    readonly hoofdvestiging: Vestiging | null;
}

/** Gegevens van een product. */
export interface Product {
    /** Naam van het product */
    naam: string;
    /** Code van het product */
    code: string;
    /** Unieke identificatie van het product binnen het platform */
    platformId: string | null;
    /** Status (Actief, Niet actief) */
    isActief: boolean | null;
    /** Indien 'false' mag het product niet getoond worden in het aanbod waar de gebruiker zelf zijn licentie kan bestellen */
    isOnlineBestelbaar: boolean | null;
}

/** Producten output. */
export interface ProductenOutput {
    /** Lijst met producten en hun key */
    producten: { [key: string]: Product; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Onderdeel van een product. */
export interface Productonderdeel {
    /** Naam van het productonderdeel. */
    naam: string;
    /** Code van het productonderdeel */
    code: string | null;
    /** Geeft aan of het productonderdeel actief is. */
    isActief: boolean | null;
    /** Geeft aan of het productonderdeel instelbaar is door de klant. */
    isInstelbaarDoorKlant: boolean | null;
    /** ID van het gekoppelde product */
    productId: string | null;
    /** Aantal gekoppelde gebruikersgroepen */
    aantalGekoppeldeGebruikersgroepen: number | null;
}

/** Uitvoer van een lijst met productonderdelen. */
export interface ProductonderdelenOutput {
    /** De lijst met productonderdelen */
    productOnderdelen: { [key: string]: Productonderdeel; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Complete gegevens van een productsamenstelling. */
export interface Productsamenstelling {
    /** Naam van de product samenstelling */
    naam: string | null;
    /** Code van de product samenstelling */
    code: string | null;
    /** Gekoppeld product */
    productId: string | null;
    /** Gekoppelde product onderdelen */
    productonderdelen: string[] | null;
    /** Aantal gekoppelde licenties */
    aantalGekoppeldeLicenties: number | null;
    /** Is de productsamenstelling actief? */
    isActief: boolean | null;
}

/** Uitvoer van een lijst met productsamenstellingen. */
export interface ProductsamenstellingenOutput {
    /** De lijst met productonderdelen. */
    productSamenstellingen: { [key: string]: Productsamenstelling; } | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Uitvoermodel van registratie kantoor. */
export interface RegistratieKantoorOutput {
    /** De gegevens van het registratiescherm. */
    registratieKantoor: RegistratieKantoor | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** De gegevens van het registratiescherm. */
export interface RegistratieKantoor {
    /** Gegevens van het schermonderdeel kantoor. */
    kantoorgegevens: Kantoorgegevens;
    /** Gegevens van het schermonderdeel contactpersoon. */
    contactpersoon: Contactpersoon;
    facturatieGegevens: FacturatieGegevens | null;
    /** Captcha response van de client */
    captchaToken: string | null;
}

/** Ggevens betreffende een kantoor */
export interface Kantoorgegevens {
    /** Naam Bedrijf. */
    bedrijfsnaam: string;
    /** KVK nummer. */
    kvkNummer: string;
    /** AFM Nummer. */
    afmVergunningsnummer: string | null;
    /** De postcode. */
    postcode: string;
    /** Het huisnummer. */
    huisnummer: string;
    /** Toevoeging op het huisnummer. */
    toevoeging: string | null;
    /** De straatnaam. */
    straat: string;
    /** De plaats. */
    plaats: string;
    /** Telefoonnummer. */
    algemeenTelefoonnummer: string;
    /** Bank (IBAN) rekening voor incasso. */
    ibanVoorIncasso: string;
}

/** Gegevens contactpersoon voor een kantoor */
export interface Contactpersoon {
    /** Voornaam. */
    voornaam: string | null;
    /** Voorletters. */
    voorletters: string;
    /** Tussenvoegsel. */
    tussenvoegsel: string | null;
    /** Achternaam. */
    achternaam: string;
    /** Geslacht Man = 0, Vrouw = 1, Neutraal = 2 */
    geslacht: ContactpersoonGeslacht | null;
    /** E-mail adres. */
    emailadres: string;
    /** E-mail adres bevestiging. */
    emailadresBevestiging: string;
    /** Telefoonnummer. */
    telefoonnummer: string;
}

/** Adres voor factuur */
export interface FacturatieGegevens {
    terAttentieVan: string | null;
    straat: string | null;
    huisnummer: string | null;
    toevoeging: string | null;
    postcode: string | null;
    plaats: string | null;
}

/** Overeenkomst */
export interface Overeenkomst {
    /** Id van de overeenkomst */
    overeenkomstId: string;
    /** Gets/sets OvereenkomstAkkoord. */
    overeenkomstAkkoord: boolean | null;
}

/** Bevat gegevens van een Subscription op de Service Bus Topic waarmee de trigger voor een Overeenkomst kan worden verkregen. */
export interface RegistreerkantoorSubscriptionOutput {
    /** Unieke ID van de overeenkomst (= naam van Topic Subscription) */
    readonly organisatieId: string | null;
    /** SAS-token waarmee lees-rechten voor de Topic Subscription verkregen worden */
    readonly sasToken: string | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van een Subscription op de Service Bus Topic waarmee de trigger voor een Overeenkomst kan worden verkregen. */
export interface OvereenkomstSubscriptionOutput {
    /** De gegevens van subscription overzicht */
    subscription: OvereenkomstSubscription | null;
    isValid: boolean | null;
    message: string | null;
    validationResults: ValidationResultModel[] | null;
}

/** Bevat gegevens van een Subscription op de Service Bus Topic waarmee de trigger voor een Overeenkomst kan worden verkregen. */
export interface OvereenkomstSubscription {
    /** Unieke ID van de overeenkomst (= naam van Topic Subscription) */
    readonly overeenkomstId: string | null;
    /** SAS-token waarmee lees-rechten voor de Topic Subscription verkregen worden */
    readonly sasToken: string | null;
}

/** Bevat de inhoud van het registratie-form. */
export interface Registreren {
    /** Gegevens van de organisatie */
    organisatie: Organisatie | null;
    /** Gegevens van de vestiging */
    vestiging: Vestiging | null;
    /** Gegevens van de medewerker */
    medewerker: Medewerker | null;
}

export interface VersionInfo {
    naam: string | null;
    versie: string | null;
    auteur: string | null;
    copyright: string | null;
    opstartDatumTijd: string | null;
}

export interface BadRequestResult {
    readonly statusCode: number | null;
}

/** Criterium waarop gezocht wordt Organisatienaam = 0, Postcode = 1, Plaats = 2, KvkNummer = 3 */
export enum Soort {
    Organisatienaam = "Organisatienaam",
    Postcode = "Postcode",
    Plaats = "Plaats",
    KvkNummer = "KvkNummer",
}

export enum HdnNodenummerGeldigVoor {
    Vestiging = "Vestiging",
    Organisatie = "Organisatie",
}

export enum LicentieovereenkomstLicentiesoort {
    Betaald = "Betaald",
    Proef = "Proef",
    Intern = "Intern",
}

export enum LicentieovereenkomstBetaalwijze {
    Incasso = "Incasso",
    Factuur = "Factuur",
}

export enum MedewerkerGeslacht {
    Man = "Man",
    Vrouw = "Vrouw",
    Neutraal = "Neutraal",
}

export enum MedewerkerKlantdossierRechtenVestigingen {
    Geen = "Geen",
    AlleenLezen = "AlleenLezen",
    LezenEnSchrijven = "LezenEnSchrijven",
}

export enum MedewerkerKlantdossierRechtenOrganisatie {
    Geen = "Geen",
    AlleenLezen = "AlleenLezen",
    LezenEnSchrijven = "LezenEnSchrijven",
}

export enum MedewerkerExGeslacht {
    Man = "Man",
    Vrouw = "Vrouw",
    Neutraal = "Neutraal",
}

export enum MedewerkerExKlantdossierRechtenVestigingen {
    Geen = "Geen",
    AlleenLezen = "AlleenLezen",
    LezenEnSchrijven = "LezenEnSchrijven",
}

export enum MedewerkerExKlantdossierRechtenOrganisatie {
    Geen = "Geen",
    AlleenLezen = "AlleenLezen",
    LezenEnSchrijven = "LezenEnSchrijven",
}

export enum ContactpersoonGeslacht {
    Man = "Man",
    Vrouw = "Vrouw",
    Neutraal = "Neutraal",
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}